<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-items">
                <template slot="button-content">
                    <i class="cus-page-white-text"></i>
                    Items ({{ tabCount }})
                </template>
                <div>
                    <b-dropdown-item @click="displayList()">
                        <i class="cus-page-white-text"></i>
                        View Items
                    </b-dropdown-item>
                </div>
                <template v-if="profileMode === 'VIEW'">
                    <li
                        class="dropdown-divider"
                        v-if="isCanCreate || isCanDelete"
                    ></li>

                    <div v-if="isCanCreate">
                        <b-dropdown-item
                            @click.prevent="addInvoiceItem()"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-add"></i>
                            New Item
                        </b-dropdown-item>
                        <b-dropdown-item
                            @click="createBundle"
                            :disabled="isHasUsersChooseInvoice"
                        >
                            <i class="cus-add"></i>
                            New Bundle
                        </b-dropdown-item>

                        <li class="dropdown-divider" v-if="isCanDelete"></li>
                    </div>
                    <b-dropdown-item
                        v-if="isCanDelete"
                        @click="deleteMultiple(true)"
                        :disabled="isHasUsersChooseInvoice"
                    >
                        <i class="cus-delete"></i>
                        Delete Items
                    </b-dropdown-item>
                </template>
            </b-nav-item-dropdown>
        </template>
        <template v-if="isDeleteMultiple">
            <div v-if="isSelected" class="cursor-pointer pl-2 py-2">
                <b
                    @click="bulkDelete()"
                    class="text-primary"
                    :class="
                        isHasUsersChooseInvoice
                            ? 'disabled cursor-not-allowed'
                            : 'cursor-pointer'
                    "
                    >Delete Selected
                </b>
                |
                <b
                    @click="deleteMultiple(false)"
                    class="text-primary cursor-pointer"
                    >Cancel
                </b>
                <span
                    v-if="isSelected"
                    class="text-muted text-center mb-0 p-2 mx-2"
                >
                    (
                    {{ selectLength }}
                    {{ selectLength == 1 ? "item" : "items" }} selected )
                </span>
            </div>
            <div v-else class="pl-2 py-2">
                <span class="text-muted cursor-not-allowed"
                    >Delete Selected</span
                >
                |
                <b
                    @click="deleteMultiple(false)"
                    class="text-primary cursor-pointer"
                    >Cancel
                </b>
            </div>
        </template>
        <b-card-text>
            <item-list
                :invoice="invoice"
                ref="itemList"
                :key="keyview"
                :isDeleteMultiple="isDeleteMultiple"
                v-on="$listeners"
                @is-item-selected="isItemSelect"
                @delete-multiple="deleteMultiple"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import ItemList from "@/components/invoice-item/item-list";
import CBILLINGS from "@/constants/billings.js";
import invoiceHelper from "@/mixins/invoice";
import { isEmpty } from "lodash";
export default {
    mixins: [invoiceHelper],
    components: {
        ItemList
    },
    data() {
        return {
            keyview: 0,
            isDeleteMultiple: false,
            isSelected: false,
            selectLength: 0
        };
    },
    props: {
        tabCount: {
            type: Number,
            default: 0
        },
        invoice: {
            type: Object,
            required: true
        },
        profileMode: {
            type: String,
            required: true
        }
    },
    computed: {
        isCanCreate() {
            return (
                !this.invoice.isPaid &&
                this.invoice.isBusinessActorActive &&
                this._hasAccess("billing.invoice.item.create") &&
                this.invoice.status != CBILLINGS.INVOICE.TYPE_LOCKED
            );
        },
        isCanDelete() {
            return (
                this._hasAccess("billing.invoice.item.delete") &&
                (!this.invoice.isPaid ||
                    this.invoice.status == CBILLINGS.INVOICE.TYPE_REOPENED) &&
                this.tabCount >= 1
            );
        },
        isHasUsersChooseInvoice() {
            return !isEmpty(
                this.$store.getters["billing/findUserChooseInvoice"](
                    this.invoice.id
                )
            );
        }
    },
    methods: {
        displayList() {
            this.keyview += 1;
            this.$root.$emit("reload-count", 1);
        },
        async addInvoiceItem() {
            let proceed = await this.checkInvoiceStatus(this.invoice.id);
            proceed
                ? this.$emit("add-invoice-item")
                : this.$emit("reload-invoice-details");
        },
        reloadItem() {
            // Render getItems when the itemList already rendered
            if (this.$refs.itemList) {
                this.$refs.itemList.getItems();
            }
        },
        async createBundle() {
            let proceed = await this.checkInvoiceStatus(this.invoice.id);
            proceed
                ? this.$emit("create-bundle")
                : this.$emit("reload-invoice-details");
        },
        async bulkDelete() {
            if (this.isHasUsersChooseInvoice) {
                return;
            }
            let proceed = await this.checkInvoiceStatus(this.invoice.id);
            proceed
                ? this.$refs.itemList.bulkDelete()
                : this.$emit("reload-invoice-details");
        },
        async deleteMultiple(val) {
            let proceed = await this.checkInvoiceStatus(this.invoice.id);
            proceed
                ? (this.isDeleteMultiple = val)
                : this.$emit("reload-invoice-details");
        },
        isItemSelect(val) {
            this.selectLength = val;
            this.isSelected = val > 0;
        }
    }
};
</script>
